<div class="dialog_main">
  <button class="dialog_close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'EnterVerificationCode' | translate }}</h2>
      <p>
        {{ 'EnterVerificationCodeSent' | translate }}
        {{
          data.signUpType === signUpType.Email
            ? ('EmailAddress' | translate)
            : ('PhoneNumber' | translate)
        }}
        {{
          data.signUpType === signUpType.Email
            ? data.data.email
            : data.data.dialCode + ' ' + data.data.phoneNo
        }}
      </p>
    </div>
    <form>
      <div class="form_feilds">
        <div class="form_group">
          <ng-otp-input
            [config]="{ length: 4, allowNumbersOnly: true }"
            #ngOtpInput></ng-otp-input>
        </div>
      </div>
      <div class="form_btn">
        <button
          class="btn btn_primary"
          type="button"
          (click)="verifyOtp()">
          {{ 'Continue' | translate }}
        </button>
      </div>

      <div [ngClass]="{ 'disabled': otpTimer > 0 }"  class="otp_timer" (click)="otpTimer === 0 ? sendOtpAgain() : ''">
        <p>
          <strong
            >
            {{ 'ResendOtp' | translate }}
            @if (otpTimer > 0) {
              <span>({{ otpTimer }})</span>
            }
          </strong>
        </p>
      </div>
    </form>
  </div>
</div>
